import React, { FunctionComponent } from "react";
import classNames from "classnames";

import "./PageWrapper.scss";

interface PageWrapperProps {
    pageTitle: string;
    className?: string;
}

const PageWrapper: FunctionComponent<PageWrapperProps> = props => {
    return (
        <div className={classNames("page-wrapper-component", props.className)}>
            <h1 className="page-wrapper-header textbig pageheadinglabel">{props.pageTitle}</h1>
            {props.children}
        </div>
    );
};

export default PageWrapper;
